// /opt/isp_erp/frontend/src/components/tickets/TechnicianAvailabilityBadge.jsx
import React, { useState, useEffect } from 'react';
import { Chip, Tooltip, Box, CircularProgress } from '@mui/material';
import axios from '../../api/axios';

const availabilityColors = {
  'DISPONIBLE': 'success',
  'OCUPADO': 'warning',
  'PERMISO_SOLICITADO': 'info',
  'PERMISO_APROBADO': 'success',
  'PERMISO_RECHAZADO': 'error'
};

const availabilityLabels = {
  'DISPONIBLE': '🟢 Disponible',
  'OCUPADO': '🟡 Ocupado',
  'PERMISO_SOLICITADO': '🔵 Permiso Solicitado',
  'PERMISO_APROBADO': '🟢 Permiso Aprobado',
  'PERMISO_RECHAZADO': '🔴 Permiso Rechazado'
};

const availabilityIcons = {
  'DISPONIBLE': '✅',
  'OCUPADO': '⏳',
  'PERMISO_SOLICITADO': '📋',
  'PERMISO_APROBADO': '✔️',
  'PERMISO_RECHAZADO': '❌'
};

export default function TechnicianAvailabilityBadge({ technicianId, technicianName }) {
  const [availability, setAvailability] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (technicianId) {
      loadAvailability();
    } else {
      setLoading(false);
    }
  }, [technicianId]);

  const loadAvailability = async () => {
    try {
      const response = await axios.get(`/tickets/tecnicos/${technicianId}/disponibilidad`);
      setAvailability(response.data);
    } catch (error) {
      console.error('Error loading technician availability:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <Chip label={technicianName || 'Sin técnico'} size="small" variant="outlined" />;
  }

  if (!technicianId) {
    return <Chip label="Sin técnico" size="small" variant="outlined" />;
  }

  const estado = availability?.estado || 'DISPONIBLE';
  const color = availabilityColors[estado] || 'default';
  const label = availabilityLabels[estado] || estado;
  const icon = availabilityIcons[estado] || '';

  return (
    <Tooltip
      title={
        <Box sx={{ p: 1 }}>
          <div><strong>{technicianName || 'Técnico'}</strong></div>
          <div>Estado: {label}</div>
          {availability?.motivo && <div>Motivo: {availability.motivo}</div>}
          {availability?.actualizado_en && (
            <div style={{ fontSize: '11px', color: '#aaa' }}>
              Actualizado: {new Date(availability.actualizado_en).toLocaleString()}
            </div>
          )}
        </Box>
      }
      arrow
      placement="top"
    >
      <Chip
        label={`${icon} ${technicianName || 'Sin técnico'}`}
        color={color}
        size="small"
        variant={estado === 'DISPONIBLE' ? 'outlined' : 'filled'}
        sx={{
          fontWeight: estado !== 'DISPONIBLE' ? 'bold' : 'normal',
          border: estado === 'PERMISO_RECHAZADO' ? '2px solid #d32f2f' : 'none'
        }}
      />
    </Tooltip>
  );
}
